/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../components/modal/Modal';
import HistoryPowerCurve from '../../historyPage/HistoryPowerCurve';
import { Button } from '@ui';
import styles from './ChargingPowerHistoryModal.module.css';

export default function ChargingPowerHistoryModal({ open, onClose, stationNumber, lastJob, plugType }) {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <div className={styles.root}>
      <Modal modalOpen={open} setModalOpen={handleClose}>
        <div className={styles.panel}>
          <div className={styles.header}>
            <h2 className={styles.title}>{t('historyPage.powerCurve')}</h2>
          </div>

          <div className={styles.body}>
            {open && stationNumber ? (
              <HistoryPowerCurve
                publicStation
                state="IN_PROGRESS"
                durationSeconds={lastJob?.durationS ?? 0}
                energyWth={lastJob?.chargedWtH ?? 0}
                expanded
                inModal
                plugType={plugType}
                stationNumber={String(stationNumber)}
              />
            ) : null}
          </div>

          <div className={styles.footer}>
            <Button type="button" variant="outline-alt" className={styles.footerCloseButton} onClick={handleClose}>
              {t('close')}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
